import * as THREE from 'three'
import { registry } from '../components-lib/registry'
import type { SceneObject } from '../types/scene'
import { getThreeObject } from './ObjectManager'

export interface PipePortWorld {
  objectId: string
  portId: string
  position: THREE.Vector3
  direction: THREE.Vector3
}

export function collectPipePortsWorld(objects: SceneObject[], excludeId?: string): PipePortWorld[] {
  const ports: PipePortWorld[] = []
  for (const obj of objects) {
    if (obj.id === excludeId) continue
    const def = registry.get(obj.type)
    if (!def?.pipePorts) continue
    const obj3d = getThreeObject(obj.id)
    if (!obj3d) continue
    obj3d.updateMatrixWorld(true)
    for (const port of def.pipePorts(obj.params ?? {})) {
      const local = new THREE.Vector3(port.localOffset[0], port.localOffset[1], port.localOffset[2])
      const position = local.clone()
      obj3d.localToWorld(position)
      const direction = new THREE.Vector3(port.direction[0], port.direction[1], port.direction[2])
      direction.transformDirection(obj3d.matrixWorld)
      ports.push({
        objectId: obj.id,
        portId: port.id,
        position,
        direction,
      })
    }
  }
  return ports
}

export function findNearestPipePortByXZ(
  x: number,
  z: number,
  objects: SceneObject[],
  options?: { excludeId?: string; threshold?: number },
): PipePortWorld | null {
  const threshold = Math.max(0.1, Number(options?.threshold ?? 3))
  let best: PipePortWorld | null = null
  let bestDist = threshold
  for (const port of collectPipePortsWorld(objects, options?.excludeId)) {
    const dist = Math.hypot(x - port.position.x, z - port.position.z)
    if (dist < bestDist) {
      bestDist = dist
      best = port
    }
  }
  return best
}
